import React from 'react';

import { useDebugActivityQuery } from 'generated/graphql';
import _ from 'lodash';
import { useLoading } from 'modules';



export function useDebugActivity() {
  const tuple = useDebugActivityQuery();
  const loading = useLoading([tuple]);

  const data = React.useMemo(() => ({
    version: tuple.data?.version ?? '',
    users: _.map(tuple.data?.users.nodes, user => ({
      id: user.id,
      fullName: user.firstName + ' ' + user.lastName,
      userType: user.type?.displayName ?? ''
    }))
  }),
  [tuple]);

  return {
    data,
    loading
  };
}
